import type { PractitionerRole } from '@common/enums';

export function hasPractitionerRole(
    employmentPractitionerRoles: PractitionerRole[] | undefined,
    expectedRole: PractitionerRole
): boolean {
    return Boolean(employmentPractitionerRoles?.some((practitionerRole) => practitionerRole === expectedRole));
}
